// Cloudflare Turnstile — невидимая капча перед созданием заявки. Обычному человеку ничего не показывается;
// если Cloudflare сомневается, прямо над страницей появляется маленькая проверка «я не робот».
// Без VUE_APP_TURNSTILE_SITE_KEY всё выключено: getTurnstileToken() вернёт null и заявка уйдёт как раньше.

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const TOKEN_TIMEOUT_MS = 60000

let scriptPromise = null
let widgetId = null
let container = null
let pending = null

function loadScript () {
  if (window.turnstile) return Promise.resolve()
  if (scriptPromise) return scriptPromise
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = SCRIPT_URL
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => {
      scriptPromise = null
      reject(new Error('TURNSTILE_LOAD_ERROR'))
    }
    document.head.appendChild(script)
  })
  return scriptPromise
}

function settle (error, token) {
  if (!pending) return
  const { resolve, reject, timer } = pending
  pending = null
  clearTimeout(timer)
  if (error) reject(error)
  else resolve(token)
}

function ensureWidget (siteKey) {
  if (widgetId !== null) return
  container = document.createElement('div')
  container.className = 'turnstile-overlay'
  // Пустой, пока Cloudflare не попросит человека кликнуть — тогда проверка всплывает внизу по центру
  Object.assign(container.style, {
    position: 'fixed',
    left: '50%',
    bottom: '24px',
    transform: 'translateX(-50%)',
    zIndex: '3000'
  })
  document.body.appendChild(container)
  widgetId = window.turnstile.render(container, {
    sitekey: siteKey,
    execution: 'execute',
    appearance: 'interaction-only',
    callback: (token) => settle(null, token),
    'error-callback': () => settle(new Error('TURNSTILE_ERROR')),
    'expired-callback': () => settle(new Error('TURNSTILE_EXPIRED'))
  })
}

// Свежий одноразовый токен на каждую заявку.
export async function getTurnstileToken () {
  const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY
  if (!siteKey) return null
  await loadScript()
  ensureWidget(siteKey)
  if (pending) settle(new Error('TURNSTILE_SUPERSEDED'))
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => settle(new Error('TURNSTILE_TIMEOUT')), TOKEN_TIMEOUT_MS)
    pending = { resolve, reject, timer }
    window.turnstile.reset(widgetId)
    window.turnstile.execute(widgetId)
  })
}

// Заголовок с токеном для запросов, защищённых капчей (вход, регистрация, сброс пароля…).
// Если токен получить не удалось, ошибка оформлена как ответ сервера CAPTCHA_FAILED — формы уже
// показывают такие ответы через $messages.
export async function captchaHeaders () {
  try {
    const token = await getTurnstileToken()
    return token ? { 'X-Turnstile-Token': token } : undefined
  } catch (error) {
    const captchaError = new Error(error.message)
    captchaError.response = { data: { message: 'CAPTCHA_FAILED' } }
    throw captchaError
  }
}
